export default {"src":"/_next/static/media/Group-25842.883e7398.svg","height":104,"width":104};